import React from 'react';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';
import RenderVideoFile from '../renderVideoFile';
import { YouTubeEmbedAttributesInterface } from '../../interfaces/tiptapInterface';
import createEmbed from './createEmbed';

export interface YouTubeEmbedOptions {
  HTMLAttributes?: YouTubeEmbedAttributesInterface;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    youTubeEmbed: {
      setYouTubeEmbed: (options: { url: string; videoId: string; themeMode?: string }) => ReturnType;
    };
  }
}

// React NodeView Component using RenderVideoFile
const YouTubeEmbedComponent: React.FC<NodeViewProps> = ({ node }) => {
  const { url, videoId } = node.attrs;

  return (
    <NodeViewWrapper className='youtube-embed-wrapper'>
      <RenderVideoFile videoId={videoId} videoName={videoId} videoUrl={url} isYouTubePreview={true} />
    </NodeViewWrapper>
  );
};

export const YouTubeEmbed = createEmbed({
  name: 'youTubeEmbed',
  tag: 'div.youtube-preview-main-div',
  component: YouTubeEmbedComponent,
  selectable: true,
  draggable: false,
  attributes: {
    url: { default: '' },
    videoId: { default: '' },
    previewImageUrl: {
      default: (attrs: YouTubeEmbedAttributesInterface) => `https://img.youtube.com/vi/${attrs?.videoId}/maxresdefault.jpg`
    },
    themeMode: { default: 'light' }
  },
  parseHTMLGetAttrs: (dom: HTMLElement) => ({
    url: dom.getAttribute('url'),
    videoId: dom.getAttribute('name'),
    previewImageUrl: `https://img.youtube.com/vi/${dom.getAttribute('name')}/maxresdefault.jpg`
  }),
  renderHTMLAttributes: (HTMLAttributes) => {
    return {
      class: 'youtube-preview-main-div',
      url: HTMLAttributes?.url,
      name: HTMLAttributes?.videoId
    };
  }
});
